<div id="heading">
    <h1>Recognitions (2f) & 12B</h1>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">About Us</a></li>
            <li class="breadcrumb-item active" aria-current="page">Recognitions</li>
        </ol>
    </nav>
</div>

<div id="recognitions">
    <div class="container-fluid">
        <div class="card pl-3 pr-3 text-justify ml-lg-5">
            <h4 class="card-title text-center ">Recognitions (2f) & 12B Certificate</h4>
            <div class="card-body text-justify">
                <div id="detail" class="text-center">
                    <pdf-viewer [src]="src" [render-text]="true" style="display: block;" id="list-view"></pdf-viewer>
                </div>
            </div>
        </div>
    </div>
</div>